module.exports = __webpack_public_path__ + "img/our-london.c5a0f9a1.svg";